if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if(this.submitButton.classList.contains('sample-quick-add')) {
        if (typeof(Storage) !== 'undefined') {
          if (localStorage.getItem('sample-product')) {
            var sampleProducts = localStorage.getItem('sample-product');
            if(sampleProducts.includes(this.submitButton.getAttribute('data-variant-id'))) {
              this.removeSample();
              this.addSample();
            }
          }
        }
      }
    }

    addSample() {
      this.submitButton.classList.remove('button--tertiary');
      this.submitButton.querySelector('.add').classList.add('hidden');
      this.submitButton.querySelector('.added').classList.remove('hidden');
    }

    removeSample() {
      document.querySelectorAll('.sample-quick-add ').forEach((button) => {
        // if (button.getAttribute("data-variant-id") == localStorage.getItem('gift-product') || button.getAttribute("data-variant-id") == localStorage.getItem('gift-product-2')) {
        //   button.classList.remove('button--tertiary');
        //   button.querySelector('.added').classList.remove('hidden');
        //   button.querySelector('.add').classList.add('hidden');
        //   button.setAttribute('disabled', '');
        // } else {
        button.classList.add('button--tertiary');
        button.querySelector('.added').classList.add('hidden');
        button.querySelector('.add').classList.remove('hidden');
        button.removeAttribute('disabled');
      })
    }
  

    getProductVariant(id) {
      return fetch('https://dphue.myshopify.com/api/2022-07/graphql.json', {
        'method': 'POST',
        'headers': {
          'X-Shopify-Storefront-Access-Token': '281ab10ea01587e3c8c091633ee7ea2b',
          'Content-Type': 'application/json',
        },
        'body': JSON.stringify({
          query: `{
                product(id: "gid://shopify/Product/` + id + `") {
                  id
                  variants (first:1) {
                    edges {
                      node {
                        id
                      }
                    }
                  }
                }
              }`
       })
      }).then(res => res.json())
        .then(data => {
          return data;
      }).catch(error => {
        console.log(error)
      })
    }

    getVariant(id) {
      return fetch('https://dphue.myshopify.com/api/2022-07/graphql.json', {
        'method': 'POST',
        'headers': {
          'X-Shopify-Storefront-Access-Token': '281ab10ea01587e3c8c091633ee7ea2b',
          'Content-Type': 'application/json',
        },
        'body': JSON.stringify({
          query: `{
                productVariant(id: "gid://shopify/ProductVariant/` + id + `") {
                  id
                }
              }`
       })
      }).then(res => res.json())
        .then(data => {
          return data;
      }).catch(error => {
        console.log(error)
      })
    }
    
    async onSubmitHandler(evt) {
      evt.preventDefault();
      document.querySelector('cart-drawer').show(false ,false);
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      if(this.submitButton.classList.contains('sample-quick-add')) {
        if (typeof(Storage) !== 'undefined') {
          var new_sample = this.submitButton.getAttribute('data-variant-id');
          var update = true;
          if (localStorage.getItem('sample-product')) {
            var old_sample = localStorage.getItem('sample-product');
            if(!old_sample.includes(new_sample)) {
              this.removeSample();
              this.addSample();
              localStorage.setItem('sample-product', new_sample);
            } else {
              update = false;
              localStorage.removeItem('sample-product');
            }
          } else {
            this.removeSample();
            localStorage.setItem('sample-product', new_sample);
          }

          var sample = {
            updates : {}
          }

          if (old_sample) {
            sample.updates[old_sample] = 0;
          }

          if (update) {
            sample.updates[new_sample] = 1;
          } else {
            sample.updates[new_sample] = 0;
          }

          fetch(window.routes.cart_update_url, {
            headers: {
              'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(sample)
          })
          .then((response) => document.querySelector('cart-drawer').updateCart())
        }

        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');

        return;
      }
      
      const config = fetchConfig('javascript');
      var bundle = false;
      // set data for bundle product-form
      if (this?.closest('.product-form')?.querySelector(".bundle[data-variant-id]")) {
        bundle = true;
        var formData = {
            "items" : [],
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          };

        this.closest('.product-form').querySelectorAll(".bundle[data-variant-id]").forEach((e) => {
          let check = true;
          formData.items.forEach((item) => {
            if(item.id == e.getAttribute("data-variant-id")) {
              item.quantity = item.quantity + 1;
              check = false;
            }
          })

          if(check) {
            formData.items.push({
              'id': parseInt(e.getAttribute("data-variant-id")),
              'quantity': 1
            });
          }

        })
        formData = JSON.stringify(formData);

      } else if (this?.closest('.buy_buttons')?.closest('.product-form')?.querySelector(".bundle[data-variant-id]")) {
        bundle = true;
        var formData = {
            "items" : [],
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          };
    
          this.closest('.buy_buttons').closest('.product-form').querySelectorAll(".bundle[data-variant-id]").forEach((e) => {
          
          let check = true;

          formData.items.forEach((item) => {
            if(item.id == e.getAttribute("data-variant-id")) {
              item.quantity = item.quantity + 1;
              check = false;
            }
          })

          if(check) {
            formData.items.push({
              'id': parseInt(e.getAttribute("data-variant-id")),
              'quantity': 1
            });
          }
        })
        formData = JSON.stringify(formData);

      } else if (this?.closest('.quiz-kit')?.querySelector(".bundle[data-variant-id]")) { 
        //--Changed for Quiz Kit
        bundle = true;
        var formData = {
            "items" : [],
            sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname
          };
        
          this.closest('.quiz-kit').querySelectorAll(".bundle[data-variant-id]").forEach((e) => {
            const object = {};
            object.id = e.getAttribute('data-variant-id');
            object.quantity = 1;
            object.properties = {};
            object.properties['_quiz_kit_id'] = (e.getAttribute("data-property"))
          let check = true;
          formData.items.forEach((item) => {
            if(item.id == object.id) {
              item.quantity = item.quantity + 1;
              check = false;
            }
          })

          if(check) {
            formData.items.push(object);
          }
          
        })
        formData = JSON.stringify(formData);

      } else if (this.form.getAttribute('data-gwp')) {
        var data = await this.getProductVariant(this.form.getAttribute("data-gwp"));
        
        var formData = {
          "items" : [],
          sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        };
        
        if (data.data.product != null) {
          formData.items.push({
            'id': data.data.product.variants.edges[0].node.id.replace('gid://shopify/ProductVariant/', ''),
            'quantity': 1
          });
        }

        var i_quantity = this.form.quantity?.value || 1
        formData.items.push({
          'id': parseInt(this.form.querySelector('input[name="id"]').value),
          'quantity': i_quantity
        });

        formData = JSON.stringify(formData);

      } else if (this.form.getAttribute('data-gwp-variant')) {
        const gwpID = this.form.getAttribute('data-gwp-variant');
        
        var formData = {
          "items" : [],
          sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        };
        
        if (gwpID != '') {
          formData.items.push({
            'id': parseInt(gwpID),
            'quantity': 1
          });
        }

        const i_quantity = this.form.quantity?.value || 1
        var id = this.form.querySelector('input[name="id"]').value;
        if (this.form.querySelector('input[name="id"]:checked')) {
          id = this.form.querySelector('input[name="id"]:checked').value;
        }
        formData.items.push({
          'id': parseInt(id),
          'quantity': i_quantity, 
          'properties': {
            gwpVariant: parseInt(gwpID)
          }
        });

        formData = JSON.stringify(formData);

      } else {
        var formData = new FormData(this.form);
        
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      }
      
      fetch(`${routes.cart_add_url}`, { ...config, body: formData})
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        this.error = false;
        if(bundle) {
          var bundleResponse = response;
          this.cartNotification.renderContents(response, bundleResponse);
        } else {
          this.cartNotification.renderContents(response);
        }

        this.checkGWPVariant(response);

        var id = window.gift_with_purchase.gift_one
        var id2 = window.gift_with_purchase.gift_two
        if (id || id2 ) {
          this.checkGiftInCart(response, id, id2)
        } else {
          this.renderCart();
        }
        // this.submitButton.classList.remove('loading');
        //   if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        //   this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        //   document.querySelector('cart-drawer').updateCart(null, response);
      }).catch((e) => {
        console.error(e);
      })
    }

    checkGiftInCart(data, id, id2) {
      fetch('/cart.js').then(res =>res.json()).then(resp => {
        if (parseInt(resp.original_total_price) / 100 > parseInt(window.gift_with_purchase.threshold)) {
          var body = {
            updates : {}
          }

          if (id != '') {
            body.updates[id] = 1;
            localStorage.setItem('gift-product', id);
          }
          
          if (id2 != '') {
            body.updates[id2] = 1;
            localStorage.setItem('gift-product-2', id);
          }

          // if (id3 != '') {
          //   body.updates[id3] = 1;
          //   localStorage.setItem('gift-product-3', id);
          // }

          if (Object.keys(body).length === 0) {
            this.renderCart();
            return;
          }

          fetch(window.routes.cart_update_url, {
            headers: {
              'Content-Type': 'application/json'
            },
            method: "POST",
            body: JSON.stringify(body)
          }).then(res => this.renderCart(data));

        } else {
          this.renderCart();
        }
      })
    }

    renderCart(data) {
      this.submitButton.classList.remove('loading');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      document.querySelector('cart-drawer').updateCart(data);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    checkGWPVariant(data) {
      fetch('/cart.js').then(res =>res.json()).then(resp => {
        //get GWPID
        var gwpID = '';
        if (data.items == undefined) return;

        for (let i = 0; i <= data.items.length; i++) {
          if (data.items[i].properties) {
            if (data.items[i].properties.gwpVariant) {
              gwpID = data.items[i].properties.gwpVariant;
              break;
            }
          }
        }

        // update quantity of gwpVariant
        if (gwpID != '') {
          var count = 0;
          var quantity = '';
          for (let i = 0; i < resp.items.length; i++) {
            if (resp.items[i].properties) {
              if (resp.items[i].properties.gwpVariant == gwpID && resp.items[i].properties.gwpVariant) {
                count++;
              }
            }
            
            if (resp.items[i].id == gwpID) {
              quantity = resp.items[i].quantity
            }
          }
          
          if (count != quantity) {
            var body = {
              updates : {}
            }
            body.updates[gwpID] = count;
            fetch(window.routes.cart_update_url, {
              headers: {
                'Content-Type': 'application/json'
              },
              method: "POST",
              body: JSON.stringify(body)
            }).then(res => this.renderCart(data));
          }
        }
      })
    }
  });
}